import { IPivotItemProps, IPivotProps, Pivot as FluentPivot, PivotItem as FluentPivotItem } from "@fluentui/react";

export type PivotItemProps = Pick<IPivotItemProps, "itemKey" | "headerText">;

export type PivotProps = Pick<IPivotProps, "selectedKey">;

export const PivotItem = FluentPivotItem;

export const Pivot = FluentPivot;
